// Port of api/fuel/app/classes/filter/package/games/game/package/nested.php
export default {
	run: function(pkg, local, global) {
		pkg.nested = (global.nested && global.nested[local.id]) ? global.nested[local.id] : []
		return pkg
	}
}
